<template>
  <div class="container" v-if="hasAnyStats">
    <div class="row justify-content-between">
      <div class="col-sm-6 col-md-2 mb-2" v-if="stats.usersTotal">
        <div class="text-center">
          <i class="fa fa-user fa-3x"></i>
          <h1 class="mb-0">{{ addThousandsPoint(stats.usersTotal) }}</h1>
          <h4 class="text-muted">People</h4>
        </div>
      </div>
      <div class="col-sm-6 col-md-2 mb-2" v-if="stats.projectsTotal">
        <div class="text-center">
          <CitSciProjectIcon size="3x" />
          <h1 class="mb-0">{{ addThousandsPoint(stats.projectsTotal) }}</h1>
          <h4 class="text-muted">Projects</h4>
        </div>
      </div>
      <div class="col-sm-6 col-md-2 mb-2" v-if="stats.observationsTotal">
        <div class="text-center">
          <i class="fa fa-binoculars fa-3x"></i>
          <h1 class="mb-0">{{ addThousandsPoint(stats.observationsTotal) }}</h1>
          <h4 class="text-muted">Observations</h4>
        </div>
      </div>
      <div class="col-sm-6 col-md-2 mb-2" v-if="stats.measurementsTotal">
        <div class="text-center">
          <i class="fa fa-ruler-vertical fa-3x"></i>
          <h1 class="mb-0">{{ addThousandsPoint(stats.measurementsTotal) }}</h1>
          <h4 class="text-muted">Measurements</h4>
        </div>
      </div>
      <div class="col-sm-6 col-md-2 mb-2" v-if="stats.locationsTotal">
        <div class="text-center">
          <i class="fa fa-map-marker fa-3x"></i>
          <h1 class="mb-0">{{ addThousandsPoint(stats.locationsTotal) }}</h1>
          <h4 class="text-muted">Locations</h4>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import CitSciProjectIcon from '../../components/common/CitSciProjectIcon.vue'

export default {
  components: {
    CitSciProjectIcon
  },
  computed: {
    ...mapGetters({
      isLoadingStats: 'about/show/isLoading',
      stats: 'about/show/stats',
    }),
    hasAnyStats() {
      return this.stats && (
        this.stats.usersTotal ||
        this.stats.projectsTotal ||
        this.stats.observationsTotal ||
        this.stats.measurementsTotal ||
        this.stats.locationsTotal
      )
    }
  },

  methods: {
    addThousandsPoint(number) {
      // Fixes browser debugger error when number is undefined
      if (number == null)
        number = 0;

      number = number.toString()
      while (true) {
        let n2 = number.replace(/(\d)(\d{3})($|,|\.)/g, '$1,$2$3')
        if (number === n2) break
        number = n2
      }
      return number
    },
  },
}

</script>

<style scoped lang="scss">
</style>
